import Header from "../../../molecules/layouts/navbar/Header";

const MobileLayout = ({ children }) => {
  return (
    <div className="flex w-full flex-col min-h-screen bg-gray-100">
      <Header />
      {children}
    </div>
  );
};

export default MobileLayout;
